import { Link } from 'gatsby';
import React from 'react';

// Third-Party

// Local
import DialogButton from '../dialogButton';

// Icons
import { EmailIcon, FacebookIcon, InstagramIcon, SupportAgent } from '../icons';

const Footer = () => {
    return (
        <footer>
            <div className="here-to-help">
                <h2>
                    Need help?
                    <br />
                    We're here for you!
                </h2>
                <div className="icon-container">
                    <a className="support-phone" href="tel:+17205757030">
                        <SupportAgent />
                        <p>(720)575-7030</p>
                    </a>
                    <a
                        className="support-email"
                        href="mailto:support@weaveiq.com"
                    >
                        <EmailIcon />
                        <p>support@weaveiq.com</p>
                    </a>
                </div>
            </div>

            <div className="lower">
                <div>
                    <h5>Contact Us</h5>
                    <p className="address">
                        5398 Manhattan Circle
                        <br />
                        Boulder, CO 80303
                        <br />
                        United States
                    </p>
                    <p>
                        <a href="tel:+17205757030" className="address">
                            (720)575-7030
                        </a>
                    </p>
                    <p>
                        <a
                            href="mailto:support@weaveiq.com"
                            className="address"
                        >
                            support@weaveiq.com
                        </a>
                    </p>
                </div>
                <div>
                    <Link to="/about-weave">
                        <h5>About</h5>
                    </Link>
                </div>
                <div>
                    <Link to="/weave-support">
                        <h5>Support</h5>
                    </Link>
                </div>

                <div className="spaced-row">
                    <DialogButton analyticsValue={2} className="call-to-action">
                        Talk to Us
                    </DialogButton>
                </div>
                <div className="social">
                    <div>
                        <a
                            href="https://www.facebook.com/useweave/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <FacebookIcon></FacebookIcon>
                        </a>
                    </div>
                    <div>
                        <a
                            href="https://www.instagram.com/weaveiq/"
                            rel="noopener noreferrer"
                            target="_blank"
                        >
                            <InstagramIcon></InstagramIcon>
                        </a>
                    </div>
                    © {new Date().getFullYear()}
                </div>
            </div>
        </footer>
    );
};

export default Footer;
